/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface AvailabilityService {
  /** @summary Search */
  searchAvailabilitySearchPost: {
    /** @summary Search */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SearchAvailabilitySearchPostBody,
        SearchAvailabilitySearchPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SearchAvailabilitySearchPostSchema,
        options: ServiceOperationMutationFnOptions<
          SearchAvailabilitySearchPostBody,
          SearchAvailabilitySearchPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<SearchAvailabilitySearchPostData, SearchAvailabilitySearchPostError>>
    ): Promise<RequestFnResponse<SearchAvailabilitySearchPostData, SearchAvailabilitySearchPostError>>;
    /** @summary Search */
    getMutationKey(
      parameters: DeepReadonly<SearchAvailabilitySearchPostParameters> | void
    ): ServiceOperationMutationKey<SearchAvailabilitySearchPostSchema, SearchAvailabilitySearchPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.availabilityService.searchAvailabilitySearchPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.availabilityService.searchAvailabilitySearchPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends SearchAvailabilitySearchPostBody, TContext = unknown>(
      parameters: DeepReadonly<SearchAvailabilitySearchPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SearchAvailabilitySearchPostSchema,
        SearchAvailabilitySearchPostData,
        SearchAvailabilitySearchPostParameters,
        TVariables,
        OperationError<SearchAvailabilitySearchPostError>,
        TContext
      >
    ): UseMutationResult<
      SearchAvailabilitySearchPostData,
      OperationError<SearchAvailabilitySearchPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.availabilityService.searchAvailabilitySearchPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.availabilityService.searchAvailabilitySearchPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<SearchAvailabilitySearchPostBody, SearchAvailabilitySearchPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SearchAvailabilitySearchPostSchema,
        SearchAvailabilitySearchPostData,
        SearchAvailabilitySearchPostParameters,
        TVariables,
        OperationError<SearchAvailabilitySearchPostError>,
        TContext
      >
    ): UseMutationResult<
      SearchAvailabilitySearchPostData,
      OperationError<SearchAvailabilitySearchPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const searchAvailabilitySearchPostTotal = qraft.availabilityService.searchAvailabilitySearchPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const searchAvailabilitySearchPostTotal = qraft.availabilityService.searchAvailabilitySearchPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SearchAvailabilitySearchPostBody,
            SearchAvailabilitySearchPostData,
            SearchAvailabilitySearchPostParameters,
            OperationError<SearchAvailabilitySearchPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchAvailabilitySearchPostSchema,
            SearchAvailabilitySearchPostBody,
            SearchAvailabilitySearchPostData,
            SearchAvailabilitySearchPostParameters,
            OperationError<SearchAvailabilitySearchPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const searchAvailabilitySearchPostPendingMutationVariables = qraft.availabilityService.searchAvailabilitySearchPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const searchAvailabilitySearchPostMutationData = qraft.availabilityService.searchAvailabilitySearchPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SearchAvailabilitySearchPostData,
        OperationError<SearchAvailabilitySearchPostError>,
        MutationVariables<SearchAvailabilitySearchPostBody, SearchAvailabilitySearchPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SearchAvailabilitySearchPostBody,
            SearchAvailabilitySearchPostData,
            SearchAvailabilitySearchPostParameters,
            OperationError<SearchAvailabilitySearchPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchAvailabilitySearchPostSchema,
            SearchAvailabilitySearchPostBody,
            SearchAvailabilitySearchPostData,
            SearchAvailabilitySearchPostParameters,
            OperationError<SearchAvailabilitySearchPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SearchAvailabilitySearchPostData,
          OperationError<SearchAvailabilitySearchPostError>,
          MutationVariables<SearchAvailabilitySearchPostBody, SearchAvailabilitySearchPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Search */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SearchAvailabilitySearchPostBody,
            SearchAvailabilitySearchPostData,
            SearchAvailabilitySearchPostParameters,
            OperationError<SearchAvailabilitySearchPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SearchAvailabilitySearchPostSchema,
            SearchAvailabilitySearchPostBody,
            SearchAvailabilitySearchPostData,
            SearchAvailabilitySearchPostParameters,
            OperationError<SearchAvailabilitySearchPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.availabilityService.searchAvailabilitySearchPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.availabilityService.searchAvailabilitySearchPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SearchAvailabilitySearchPostBody,
              SearchAvailabilitySearchPostData,
              SearchAvailabilitySearchPostParameters,
              OperationError<SearchAvailabilitySearchPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SearchAvailabilitySearchPostSchema,
              SearchAvailabilitySearchPostBody,
              SearchAvailabilitySearchPostData,
              SearchAvailabilitySearchPostParameters,
              OperationError<SearchAvailabilitySearchPostError>,
              TContext
            >
      ):
        | Mutation<
            SearchAvailabilitySearchPostData,
            SearchAvailabilitySearchPostError,
            MutationVariables<SearchAvailabilitySearchPostBody, SearchAvailabilitySearchPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SearchAvailabilitySearchPostBody,
              SearchAvailabilitySearchPostData,
              SearchAvailabilitySearchPostParameters,
              OperationError<SearchAvailabilitySearchPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SearchAvailabilitySearchPostSchema,
              SearchAvailabilitySearchPostBody,
              SearchAvailabilitySearchPostData,
              SearchAvailabilitySearchPostParameters,
              OperationError<SearchAvailabilitySearchPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SearchAvailabilitySearchPostData,
          SearchAvailabilitySearchPostError,
          MutationVariables<SearchAvailabilitySearchPostBody, SearchAvailabilitySearchPostParameters>,
          TContext
        >
      >;
    };
    schema: SearchAvailabilitySearchPostSchema;
    types: {
      parameters: SearchAvailabilitySearchPostParameters;
      data: SearchAvailabilitySearchPostData;
      error: SearchAvailabilitySearchPostError;
      body: SearchAvailabilitySearchPostBody;
    };
  };
}
/** @summary Search */
export const searchAvailabilitySearchPost = {
  schema: {
    method: 'post',
    url: '/availability/search',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchAvailabilitySearchPostSchema;
  [QraftServiceOperationsToken]: AvailabilityService['searchAvailabilitySearchPost'];
};
export const availabilityService = {
  searchAvailabilitySearchPost,
} as const;
type SearchAvailabilitySearchPostSchema = {
  method: 'post';
  url: '/availability/search';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type SearchAvailabilitySearchPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type SearchAvailabilitySearchPostData =
  paths['/availability/search']['post']['responses']['200']['content']['application/json'];
type SearchAvailabilitySearchPostError =
  paths['/availability/search']['post']['responses']['422']['content']['application/json'];
type SearchAvailabilitySearchPostBody =
  paths['/availability/search']['post']['requestBody']['content']['application/json'];
